import script from "./ShopCartOrderSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopCartOrderSummary.vue?vue&type=script&lang=ts&setup=true"

import "./ShopCartOrderSummary.vue?vue&type=style&index=0&id=747ac3f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-747ac3f0"]])

export default __exports__